const TAG_GROUPS  = {
  PILLARS : 1,
  WORKOUT_TYPE : 3,
  CONTENT_TYPE : 10,
};

export default TAG_GROUPS;
